module.exports = __webpack_public_path__ + "static/image4-53361c3127cc3f8ff402d7d0fdc3babc.jpg";